<template>
    <div class="tooltips-info">
        <p>Hi~ 我是小易，AI智能助手</p>
        <p>我的知识库涵盖了公司所有产品、解决方案、案例、新闻等知识，对公司产品信息、公司动态都了如指掌，快来体验一下吧~</p>
    </div>
</template>

<script>
export default {
    name: 'QuestionToolTips',
    components: {
    },
    props: {
    },
    data () {
        return {
            robotName: '',
            robotAvatar: ''
        };
    },
    created () {
    },
    methods: {
    }
};
</script>

<style lang="less">
.tooltips-info {
    color: #4b5569;
    font-size: 14px;
    line-height: 20px;
    margin: 0 20px;
}
@media (max-height: 600px) {
    .tooltips-info {
      display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-demo/components/question-tooltips.vue